import React from 'react';
import { Chip, Tooltip } from '@mui/material';
import GroupsIcon from '@mui/icons-material/Groups';

type Props = {
  count?: number | null;
};

const GroupOrderChip: React.FC<Props> = ({ count }) => {
  if (!count || count < 2) return null;

  return (
    <Tooltip title={`Este ingresso faz parte de um pedido em grupo com ${count} ${count === 1 ? 'pessoa' : 'pessoas'}`}>
      <Chip
        size="small"
        icon={<GroupsIcon sx={{ fontSize: '1rem !important' }} />}
        label={`Grupo · ${count}`}
        sx={{
          height: 22,
          fontWeight: 700,
          fontSize: '0.72rem',
          bgcolor: 'rgba(75, 27, 122, 0.08)',
          color: '#4b1b7a',
          '& .MuiChip-icon': { color: '#4b1b7a' },
        }}
      />
    </Tooltip>
  );
};

export default GroupOrderChip;
